import { createSelector } from 'reselect';
import CarrierMailRegistrationDeviceDeliverySummaryColumns from '../../containers/CarrierMailRegistrationDeviceDeliverySummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierMailRegistrationDeviceDeliverySummaryColumns);
